/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'breakpoints',
    'javascript-debounce'
],
function(
    $,
    pip,
    breakpoints,
    debounce
){
  var MAX_DISPLAYABLE_ITEMS = 4;
  var MEDIUM = 'Medium';
  var LARGE_STAGE_WIDTH = 1040;
  var SMALL_STAGE_WIDTH = 640;

  var view = {
    selectors: {
      relatedSearchWrapper: '#br-related-search',
      relatedProductsWrapper: '#br-related-products',
      toggleListItemsButton: '.view-all-items',
      hiddenRelatedSearchListItems: '.hidden-item',
      lazyLoadImages: '.related-products-image',
      owlStage: '.owl-stage',
      owlItem: '.owl-item'
    },
    classes: {
      hiddenRelatedSearchListItemsClass: 'hidden-item',
      hideListItemsButtonClass: 'view-all-items--hidden'
    },
    init: function initView() {

      if (breakpoints.isActiveBreakpointEqualToOrSmallerThan(MEDIUM)) {
        viewModel.isMobileChannel = true;
        view.initToggleListItemsButton();
      }
      $(window).on('resize.breakpoints', function() {
        debounce(view.updateDOM.callOnResize(), 250);
      });
      view.updateDOM.lazyLoadImages();

      view.initDOMEventListeners();
    },
    initToggleListItemsButton: function initToggleListItemsButton() {
      if (model.relatedSearchListItems.length > MAX_DISPLAYABLE_ITEMS) {
        view.updateDOM.hideExtraListItems();
        $(view.selectors.toggleListItemsButton).removeClass(view.classes.hideListItemsButtonClass);
      }
    },

    updateDOM: {
      updateToggleListItemsText: function updateToggleListItemsText() {
        var $toggleListItemsButton = $(view.selectors.toggleListItemsButton);
        $toggleListItemsButton.text() === '+ See All'? $toggleListItemsButton.text('- See Less') : $toggleListItemsButton.text('+ See All')
      },
      resetToggleListItemsButtonText: function resetToggleListItemsButtonText() {
        $(view.selectors.toggleListItemsButton).text('+ See All').removeClass(view.classes.hideListItemsButtonClass);
      },
      updateButtonOnResize: function updateButtonOnResize() {
        if (breakpoints.isActiveBreakpointEqualToOrSmallerThan(MEDIUM) && !viewModel.isMobileChannel && model.relatedSearchList.length && !!(model.relatedSearchListItems.length > MAX_DISPLAYABLE_ITEMS)) {
          viewModel.isMobileChannel = true;
          view.updateDOM.resetToggleListItemsButtonText();
          view.updateDOM.hideExtraListItems();
        }
        if (breakpoints.isActiveBreakpointEqualToOrLargerThan(MEDIUM) && viewModel.isMobileChannel) {
          viewModel.isMobileChannel = false;
          model.relatedSearchListItems.filter(view.selectors.hiddenRelatedSearchListItems).css('display', 'inline-block');
        }
      },
      hideExtraListItems: function hideExtraListItems () {
        model.relatedSearchListItems.each( function(itemCount) {
          if (itemCount > (MAX_DISPLAYABLE_ITEMS - 1)) {
            $(this).addClass(view.classes.hiddenRelatedSearchListItemsClass).css('display','none');
          }
        });
      },
      lazyLoadImages: function lazyLoadImages () {
        $(view.selectors.lazyLoadImages).each( function (imageCount, imageElement) {
          var thisImageElement = $(imageElement);
          var updatedUrl = $(thisImageElement).attr('image-url').replace('_1000.','_400.');
          thisImageElement.attr('src', updatedUrl);
          thisImageElement.on('load', function(){
            $(this).removeAttr('image-url')
          });
        });
      },
      updateCarouselStageWidthOnResize: function updateCarouselStageWidthOnResize () {
        if (breakpoints.isActiveBreakpointEqualToOrSmallerThan(MEDIUM)) {
          $(view.selectors.relatedProductsWrapper).find(view.selectors.owlStage).css('width', SMALL_STAGE_WIDTH+'px');
        }
        if (breakpoints.isActiveBreakpointEqualToOrLargerThan(MEDIUM)) {
          $(view.selectors.relatedProductsWrapper).find(view.selectors.owlStage).css('width', LARGE_STAGE_WIDTH+'px');
        }
      },
      callOnResize: function callOnResize() {
        view.updateDOM.updateButtonOnResize();
        view.updateDOM.updateCarouselStageWidthOnResize();
      }
    },
    initDOMEventListeners: function initDOMEventListeners() {
      $(document).off('.relatedProducts');
      $(document).on('click.relatedProducts', '#br-related-products .more-link', function(e) {
        e.preventDefault();
        var currentProduct = {};

        currentProduct = $(this).closest(view.selectors.owlItem);

        currentProduct.addClass('largeView').parent('');
      });
      $(document).on('click.relatedProducts', '#br-related-products .largeView-close', function(e) {
        e.preventDefault();
        var currentProduct = $(this).closest('.largeView');
        currentProduct.removeClass('largeView');
      });

      $(document).off('.relatedSearch');
      $(document).on('click.relatedSearch', view.selectors.toggleListItemsButton, function(e) {
        view.updateDOM.updateToggleListItemsText();
        $(view.selectors.hiddenRelatedSearchListItems).toggle('fast');
      });
    },
  }

  var viewModel = {
    isMobileChannel: false,
  };

  var model = {
    relatedSearchList: $(view.selectors.relatedSearchWrapper).find('.related-search__list'),
    relatedSearchListItems: $(view.selectors.relatedSearchWrapper).find('li')
  };

  return {
    init: function() {
      view.init();
    },
    view: view,
    viewModel: viewModel,
    model: model
  };
});

}.call(window));